module.exports = __webpack_public_path__ + "img/n1.385d6028.png";